import React from 'react'
import Select from 'react-select'
import LinkItem from './LinkItem'
import { sortOpts } from '../../utils/utils'

export default class LinkListForm extends React.Component {

  constructor(props){
    super(props);
    this.state = {
      data: {
        link_order_id: props.order.order_id,
        link_filetype_id: 0,
        link_desc: '',
        link_url: '',
        link_active: 1
      },
      errors: {},
      adding: false
    };
  }

  startAdd = () => {
    this.setState({
      adding: true,
      data: {
        ...this.state.data,
        link_desc: '',
        link_url: ''
      }
    });
  }

  cancelAdd = () => {
    this.setState({adding:false});
  }

  updateInput = e => {
    this.setState({
      data:{
        ...this.state.data,
        [e.target.name]: e.target.value
      }
    });
  }

  updateFiletype = e => {
    this.setState({
      data: {
        ...this.state.data,
        link_filetype_id: e.value
      }
    });
  }

  saveLink = e => {
    e.preventDefault();
    if(!(this.state.data.link_desc || this.state.data.link_url)) {
      this.cancelAdd();
    }
    else {
      this.props.editLink(this.state.data, err => {
        if (err) {
          this.setState({errors: err});
          return;
        }
        this.setState({
          errors: {},
          adding: false
        });
      });
    }
  }

  render() {

    const { links, order, editLink, filetypeId, filetypes } = this.props;
    const { data, adding, errors } = this.state;

    const activeData = links.filter(el => {
      return (el.link_active === 1 && (
        filetypeId === 0 || el.link_filetype_id === filetypeId
      ));
    });

    const mappedData = activeData.map( el => {
      return <LinkItem
        editLink={editLink}
        order={order}
        key={el.link_id}
        link={el}
        filetypes={filetypes}
      />
    });

    const filetypesOpt = [];
    for (let key in filetypes){
      if(filetypes.hasOwnProperty(key) && (filetypes[key].filetype_active === 1
        || filetypes[key].filetype_id === data.link_filetype_id)) {
        filetypesOpt.push({value:filetypes[key].filetype_id,label:filetypes[key].filetype_desc});
      }
    }
    filetypesOpt.sort(sortOpts);

    const addLinkForm = adding ?
      <tr>
        <td>
          {errors.form && <div className="alert alert-danger">{errors.form}</div>}
          <div className="form-group">
            <input type="text"
              className="form-control"
              value={data.link_desc}
              placeholder="Описание"
              name="link_desc"
              onChange={this.updateInput}
            />
          </div>
          <button  type="button" className="btn btn-success btn-sm"
            onClick={this.saveLink} title="Сохранить">
            <span className="glyphicon glyphicon-save"></span>
          </button>{" "}
          <button type="button" className="btn btn-default btn-sm"
            onClick={this.cancelAdd} title="Отменить">
            <span className="glyphicon glyphicon-remove"></span>
          </button>
        </td>
        <td>
          <Select
            clearable={false}
            options={filetypesOpt}
            value={data.link_filetype_id}
            onChange={this.updateFiletype}
            placeholder="Тип файла"
          />
        </td>
        <td>
          <div className="form-group">
            <textarea type="text"
              rows="2"
              className="form-control"
              value={data.link_url}
              placeholder="Адрес"
              name="link_url"
              onChange={this.updateInput}
            />
          </div>
        </td>
      </tr> :
      <tr onClick={this.startAdd} >
        <td colSpan="3"><u>Добавить ссылку</u></td>
      </tr>;

    return (
      <table className="table">
        <thead>
          <tr>
            <th className="col-sm-5">Описание</th>
            <th className="col-sm-2">Тип</th>
            <th className="col-sm-5">Адрес</th>
          </tr>
        </thead>
        <tbody>
          {mappedData}
          {addLinkForm}
        </tbody>
      </table>
    )

  }
}



// WEBPACK FOOTER //
// ./src/components/order/LinkListForm.js